import angular from 'angular';

import template from './points-removed-row.html';
import './points-removed-row.less';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  records: state.user.users,
  subComponent: state.statsbar.activeComponent,
});

angular.module('myConsultApp').directive('pointsRemovedRow', ($ngRedux, $http, ENV, $timeout) => {
  return {
    scope: {
      pointsData: '=',
      expandedStatus: '=',
    },
    template,
    restrict: 'E',
    link: ($scope, elem) => {
      $scope.type = $scope.pointsData.points_removed ? 'for' : 'from';
      $scope.ids =
        $scope.type === 'for'
          ? $scope.pointsData.points_removed
              .map((obj) => obj.removed_points.redemption_id)
              .filter((id) => !!id)
          : $scope.pointsData.points_removed_from
              .map((obj) => obj.source_points.transaction_id)
              .filter((id) => !!id);

      const activitiesObject =
        $scope.type === 'for'
          ? $scope.pointsData.points_removed
          : $scope.pointsData.points_removed_from;

      const field = $scope.type === 'for' ? 'removed_points' : 'source_points';

      const activities = activitiesObject
        .map((obj) => obj[field].activities)
        .flat(1)
        .filter(
          (activity) =>
            !!activity &&
            activity.activity_name !== 'pos purchased' &&
            activity.activity_name !== 'rewards redeemed',
        );

      $scope.record = {
        redemptions: [],
        transactions: [],
        activities,
      };

      $scope.shouldBeExpanded = false;
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);

      $scope.getTransactions = () => {
        $scope.ids.forEach((id) => {
          $scope
            .getTransaction($http, ENV, id)
            .then((response) => {
              $timeout(() => {
                $scope.record.transactions.push(response);
              });
            })
            .catch((err) => {
              $scope.record.transactions.push({ error: err.data.transactions.detail });
            });
        });
      };

      $scope.getRedemptions = () => {
        $scope.ids.forEach((id) => {
          $scope
            .getRedemption($http, ENV, id)
            .then((response) => {
              $timeout(() => {
                $scope.record.redemptions.push(response);
              });
            })
            .catch((err) => {
              $scope.record.redemptions.push({ error: err.data.redemptions.detail });
            });
        });
      };

      $scope.getRecords = () => {
        if ($scope.type === 'for' && $scope.ids.length > 0) {
          $scope.getRedemptions();
        } else if ($scope.ids.length > 0) {
          $scope.getTransactions();
        }
      };

      const expandedStatusListerner = $scope.$watch('expandedStatus', (newVal, oldVal) => {
        $scope.shouldBeExpanded =
          newVal || oldVal ? !$scope.shouldBeExpanded : $scope.shouldBeExpanded;
        if (
          $scope.shouldBeExpanded &&
          $scope.record.redemptions?.length === 0 &&
          $scope.record.transactions?.length === 0
        ) {
          $scope.getRecords();
        }
      });

      $scope.$on('destroy', () => {
        expandedStatusListerner();
      });
    },
  };
});
